// extracted by mini-css-extract-plugin
module.exports = {"mainCategory":"Categories_mainCategory__ZE5gL"};